import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import { getVendorName } from "../../../utils/getVendorName";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import toast from "react-hot-toast";
import { formatter } from "../../../utils/numberFormatter";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { useFetchUserPointSummaryModenikMutation } from "../../../features/tenant/ModenikApi/modenikApi";

const ModenikPointSummary = () => {
    const [
        fetchModenikPointsSummary,
        {
            data: modenikPointSummaryData,
            isLoading: modenikPointSummaryIsLoading,
            error: modenikPointSummaryError,
        },
    ] = useFetchUserPointSummaryModenikMutation();

    const [
        fetchModenikPointsSummaryCsv,
        {
            data: borosilPointSummaryCsvData,
            isLoading: borosilPointSummaryCsvIsLoading,
            error: borosilPointSUmmaryCsvError,
        },
    ] = useFetchUserPointSummaryModenikMutation();

    const navigate = useNavigate();

    const [totalRows, setTotalRows] = useState(0);
    const [data, setData] = useState([])

    const [viewPointsSummaryToggle, setViewPointsSummaryToggle] = useState(false);
    const [pointsData, setPointsData] = useState(null);


    const [csvData, setCsvData] = useState(null);

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const initialRequest = {
        mobile: "",
        user_id: "",
        startDate: "",
        endDate: "",
        startMonth: null,
        startYear: null,
        endMonth: null,
        endYear: null,
        limit: limit,
        offset: offset
    };

    const [request, setRequest] = useState(initialRequest);

    const clearFilters = () => {
        setRequest(initialRequest);
    };

    const fetchAllPointsSummaryFunc = () => {
        const { startDate, endDate, ...rest } = request;

        let updatedRequest = { ...rest };

        if (startDate) {
            const [year, month] = startDate.split("-");
            updatedRequest.startYear = year;
            updatedRequest.startMonth = month;
        }

        if (endDate) {
            const [year, month] = endDate.split("-");
            updatedRequest.endYear = year;
            updatedRequest.endMonth = month;
        }

        const queryParams = new URLSearchParams(updatedRequest).toString();

        fetchModenikPointsSummary({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            queryParams: queryParams
        });
    };


    const handlefetchAllPointsSummaryCsvFunc = () => {

        const { startDate, endDate, ...rest } = request;

        let updatedRequest = { ...rest };

        if (startDate) {
            const [year, month] = startDate.split("-");
            updatedRequest.startYear = year;
            updatedRequest.startMonth = month;
        }

        if (endDate) {
            const [year, month] = endDate.split("-");
            updatedRequest.endYear = year;
            updatedRequest.endMonth = month;
        }

        updatedRequest.limit = 10000;
        updatedRequest.offset = 0;

        const queryParams = new URLSearchParams(updatedRequest).toString();

        fetchModenikPointsSummaryCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            queryParams: queryParams
        });
    }

    useEffect(() => {
        // if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id != 38 || ) {
        //     navigate(`/genefied/${getVendorName()}/`);

        // }
        fetchAllPointsSummaryFunc();
    }, [request, limit, offset]);


    useEffect(() => {
        if (modenikPointSummaryData && modenikPointSummaryData.body) {
            console.log("modenikPointSummaryData", modenikPointSummaryData);
            setData(modenikPointSummaryData.body.data);
            setTotalRows(modenikPointSummaryData.body.total_records)
        }

        if (modenikPointSummaryError) {
            if (modenikPointSummaryError.status != 500) {
                toast.error(`${modenikPointSummaryError?.data?.message}`, { id: "modenikPointSummaryError" })
            } else {
                toast.error("Something went wrong", { id: "modenikPointSummaryError" })
            }
            console.log("modenikPointSummaryError ", modenikPointSummaryError);
        }
    }, [modenikPointSummaryData, modenikPointSummaryError]);


    useEffect(() => {
        if (borosilPointSummaryCsvData && borosilPointSummaryCsvData.body) {
            console.log("borosilPointSummaryCsvData", borosilPointSummaryCsvData);
            setCsvData(borosilPointSummaryCsvData?.body?.data);
            // setData(borosilPointSummaryCsvData.body.data);
            // setTotalRows(borosilPointSummaryCsvData.body.total_records)
        }

        if (borosilPointSUmmaryCsvError) {
            if (borosilPointSUmmaryCsvError.status != 500) {
                toast.error(`${borosilPointSUmmaryCsvError?.data.message}`, { id: "borosilPointSUmmaryCsvError" })
            } else {
                toast.error("Something went wrong", { id: "borosilPointSUmmaryCsvError" })
            }
            console.log("borosilPointSUmmaryCsvError ", borosilPointSUmmaryCsvError);
        }
    }, [borosilPointSummaryCsvData, borosilPointSUmmaryCsvError]);


    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Mobile",
            selector: (row) => row.mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "User ID",
            selector: (row) => row.user_id,
            sortable: true,
            width: "150px",
        },
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
            width: "220px",
        },
        {
            name: "Total Points",
            selector: (row) => formatter.format(row.total_earned),
            sortable: true,
            width: "220px",
        },
        {
            name: "Total Balance",
            selector: (row) => formatter.format(row.total_balance),
            sortable: true,
            width: "220px",
        },
        {
            name: "Tds",
            selector: (row) => formatter.format(row.total_tds_deducted),
            sortable: true,
            width: "220px",
        },
        {
            name: "Total Redeemed",
            selector: (row) => formatter.format(row.total_redeemed),
            sortable: true,
            width: "220px",
        },
       
        {
            name: "",
            cell: (row) => {
                return (
                    <div>
                        <button
                            onClick={() => {
                                setViewPointsSummaryToggle(true);
                                setPointsData(row);
                            }}
                            className="flex justify-center items-center rounded bg-green-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                        >
                            View
                        </button>
                    </div>
                );
            },
            sortable: true,
        },
    ];



    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Users Point Summary
                        <LinksComponent />
                    </div>
                    <div className="p-3">
                        <div className="mb-2">
                            <CustomExport fetchData={handlefetchAllPointsSummaryCsvFunc}
                                data={csvData}
                                defaultColumnExport={[
                                    "name",
                                    "mobile",
                                    "user_id",
                                    "total_earned",
                                    "total_balance",
                                    "total_redeemed"
                                ]}
                                filename="userPointSummary"
                            />
                        </div>
                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                // title={"Product List"}
                                data={data}
                                loading={modenikPointSummaryIsLoading}
                                totalRows={totalRows}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            >
                                <div className="border-b pb-3 border-gray-300 bg-gray-50 rounded-t-lg">
                                    <div className="flex  space-x-2 justify-end">
                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    Mobile
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="Mobile..."
                                                    required
                                                    value={request.mobile}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setRequest((prevState) => {
                                                            return { ...prevState, mobile: newValue };
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    Name
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="Name..."
                                                    required
                                                    value={request.name}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setRequest((prevState) => {
                                                            return { ...prevState, name: newValue };
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="w-52 h-10 ">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    User ID
                                                </label>
                                                <input
                                                    type="search"
                                                    id="default-search"
                                                    className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                                    placeholder="User ID..."
                                                    required
                                                    value={request.user_id}
                                                    onChange={(e) => {
                                                        const newValue = e.target.value;
                                                        setRequest((prevState) => {
                                                            return { ...prevState, user_id: newValue };
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Start Month-Year */}
                                        <div className="w-52 h-10">
                                            <div className="relative searchin">
                                                <label className="block text-sm font-medium text-gray-900 mb-1">Start Month</label>
                                                <input
                                                    type="month"
                                                    value={request.startDate}
                                                    onChange={(e) =>
                                                        setRequest((prev) => ({ ...prev, startDate: e.target.value }))
                                                    }
                                                    className="w-full px-2 py-1 border rounded"
                                                />
                                            </div>
                                        </div>

                                        {/* End Month-Year */}
                                        <div className="w-52 h-10">
                                            <div className="relative searchin">
                                                <label className="block text-sm font-medium text-gray-900 mb-1">End Month</label>
                                                <input
                                                    type="month"
                                                    value={request.endDate}
                                                    onChange={(e) =>
                                                        setRequest((prev) => ({ ...prev, endDate: e.target.value }))
                                                    }
                                                    className="w-full px-2 py-1 border rounded"
                                                />
                                            </div>
                                        </div>


                                        <div className="flex flex-row  gap-2 h-10">
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    &nbsp;
                                                </label>
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right  p-2"
                                                    onClick={() => {
                                                        fetchAllPointsSummaryFunc();
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            <div className="relative searchin">
                                                <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                    &nbsp;
                                                </label>
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right p-2"
                                                    onClick={() => {
                                                        clearFilters();
                                                    }}
                                                >
                                                    Clear Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </DataTableComponent>

                        </div>

                        {viewPointsSummaryToggle && (
                            <ModalComponent
                                size="xl"
                                show={viewPointsSummaryToggle}
                                setShow={setViewPointsSummaryToggle}
                            >
                                <div className="w-full">
                                    <div className="w-full p-4">
                                        <h2 className="text-lg font-semibold mb-4">Monthly Point Summary</h2>
                                        {Array.isArray(pointsData?.month_wise_data) && pointsData?.month_wise_data.length > 0 ? (
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full table-auto border border-gray-300 text-sm">
                                                    <thead className="bg-gray-100">
                                                        <tr>
                                                            <th className="border px-4 py-2 text-left">Month</th>
                                                            <th className="border px-4 py-2 text-left">Year</th>
                                                            <th className="border px-4 py-2 text-left">Points Earned</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {pointsData?.month_wise_data.map((item, index) => (
                                                            <tr key={index} className="hover:bg-gray-50">
                                                                <td className="border px-4 py-2">{item.month}</td>
                                                                <td className="border px-4 py-2">{item.year}</td>
                                                                <td className="border px-4 py-2">{item.points_earned}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-gray-500">No data available</div>
                                        )}

                                    </div>
                                </div>
                            </ModalComponent>
                        )}




                    </div>
                </div>
            </div>
        </>
    );
};

export default ModenikPointSummary;
